disableNetworkFetches